export default () => ({
    accord: `Accord`,
    advance: `Advance`,
    aegis: `Aegis`,
    aep: `AEP`,
    afa_cwa: `AFA-CWA`,
    artists_union_england: `Artists' Union England`,
    aslef: `ASLEF`,
    atl: `ATL`,
    balpa: `BALPA`,
    bda: `BDA`,
    bectu: `BECTU`,
    bfawu: `BFAWU`,
    bos_tu: `BOS TU`,
    bsu: `BSU`,
    community: `Community`,
    csp: `CSP`,
    cwu: `CWU`,
    eis: `EIS`,
    equity: `Equity`,
    fbu: `FBU`,
    fda: `FDA`,
    gmb: `GMB`,
    hcsa: `HCSA`,
    mu: `MU`,
    naco: `NACO`,
    naht: `NAHT`,
    napo: `Napo`,
    nass: `NASS`,
    nasuwt: `NASUWT`,
    nautilus_international: `Nautilus International`,
    neu: `NEU`,
    ngsu: `NGSU`,
    nuj: `NUJ`,
    num: `NUM`,
    nut: `NUT`,
    pcs: `PCS`,
    pfa: `PFA`,
    poa: `POA`,
    prospect: `Prospect`,
    rcm: `RCM`,
    rcn: `RCN`,
    rmt: `RMT`,
    so_r: `SoR`,
    scp: `SCP`,
    suwbbs: `SUWBBS`,
    tssa: `TSSA`,
    ucac: `UCAC`,
    ucatt: `UCATT`,
    ucu: `UCU`,
    unison: `UNISON`,
    unite: `Unite`,
    urtu: `URTU`,
    usdaw: `USDAW`,
    voice: `Voice`,
    wggb: `WGGB`,
    not_known: LanguageManager.getString('union_selection_not_known'),
    no_union: LanguageManager.getString('union_selection_no_union'),
    not_listed: LanguageManager.getString('union_selection_not_listed'),
})